import { VOLUME_UNITS, WEIGHT_UNITS } from '../measurement';
import type { VehicleTemplate } from '../vehicle-template/vehicle-template.interface';
import { VEHICLE_PROFILES } from '../vehicle-template/vehicle-template.interface';
import { baseDocumentFactory } from './base-document.factory';
import { ObjectFactory } from './object.factory';

export class VehicleTemplateFactory extends ObjectFactory<VehicleTemplate> {
  protected getDefaults(): VehicleTemplate {
    return {
      ...baseDocumentFactory.build(),
      code: 'standard-vehicle',
      maxOrderCapacity: 50,
      maxVolumeCapacity: { unit: VOLUME_UNITS.M3, value: 10 },
      maxWeightCapacity: { unit: WEIGHT_UNITS.KG, value: 500 },
      name: 'Standard Vehicle',
      profile: VEHICLE_PROFILES.LIGHTWEIGHT_VEHICLE,
    };
  }
}

export const vehicleTemplateFactory = new VehicleTemplateFactory();
